"use client";
import React, { useContext, useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import $ from "jquery";
 
import Icons from "../Icons/index";

import { Context } from "../contexts/AppContext";
import { getData } from "../../lib/utils";

import Header from "../Headers/Header";
import GalleryManager from "../Gallery/GalleryManager";
import StudioManager from "./StudioManager";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import LinkMedia from "../PropertyList/LinkMedia";

const SideNav = () => {

 
 
  const { galleryId, section } = useParams();

  
  const [selectedFolderIndex, setSelectedFolderIndex] = useState(null);
  const [selectedFolder,setSelectedFolder]=useState(false)
  

  const { value } = useContext(Context);
 
  const [appState, setAppState] = value; 
  const [fullData, setFullData] = useState(appState.allFolderData);

   
  
  const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  let Icon = Icons[capitalizeFirstLetter(section)+"C"];
 
  //console.log(appState.activePanel, "Studio Side Nav111",capitalizeFirstLetter(section)+"C")

  useEffect(()=>{
    setAppState((prevState) => {
      return { ...prevState, 
        activePanel:capitalizeFirstLetter(section)+"C",
     
      
      };
    });
  
  },[])

    const [modalOpen, setModalOpen] = useState(appState.modalData);
 
  const mainDiv = useRef();
useEffect(() => {
  
  setModalOpen(appState.modalData); // modalOpen को अपडेट करें
}, [appState.modalData]);
 
  useEffect(() => {
    const adjustHeight = () => {
      $("#mainDiv").css({ height: window.innerHeight - $("#header").height() + "px" });
    };
    setTimeout(adjustHeight, 1000);
    adjustHeight();
  }, [fullData]);


  

 const BASE_ITEMS = [
  {
    id: "photos",
    name: "PhotosC",
    icon: "Photo",
    txt: "Add Photos",
  },

  ...(appState?.adminDetails?.plan?.planType !== "imageonly"
    ? [
        {
          id: "videos",
          name: "VideosC",
          icon: "Video",
          txt: "Add Videos",
        },
        {
          id: "linkmediamain",
          name: "LinkMediaMainC",
          icon: "Images",
          txt: "Attach Video",
        },
      ]
    : []),

  {
    id: "heading",
    name: "HeadingC",
    icon: "Text",
    txt: "Heading",
  },
  {
    id: "background",
    name: "BackgroundC",
    icon: "Images",
    txt: "Background",
  },
  {
    id: "music",
    name: "MusicC",
    icon: "Music",
    txt: "Add Music",
  },
  {
    id: "styles",
    name: "StylesC",
    icon: "Style",
    txt: "Set Styles",
  },
  {
    id: "settings",
    name: "SettingsC",
    icon: "Setting",
    txt: "Settings",
  },
  {
    id: "deliver",
    name: "DeliverC",
    icon: "Delivery",
    txt: "Share & Invite",
   },
  ,
  {
    id: "analytics",
    name: "AnalyticsC",
    icon: "Analytics",
    txt: "Analytics",
  },
];

  return (
    <div className="relative min-h-screen">
      <Header />
       
      <div className="md:flex min-h-screen pb-8 border-2" id="mainDiv" ref={mainDiv}>
      
        <Sidebar BASE_ITEMS={BASE_ITEMS} fullData={fullData} setAppState={setAppState} appState={appState} />
        <ContentArea Icon={Icon} />
      </div>
    </div>
  );
};






//Side Bar component
const Sidebar = ({ BASE_ITEMS, fullData, setAppState, appState }) => {

  const { galleryId, section } = useParams();
  return(

 
  <div
    className=" text-[0.9rem] font-semibold sidebar bg-[#eeeeee] text-black-800 w-[180px] space-y-5 py-3 absolute inset-y-0 left-0 transform -translate-x-full md:relative md:translate-x-0 transition duration-200 ease-in-out"
  >
    <Link key={'link'} to={`/studio/galleries`}>
    <button className="w-full relative overflow-hidden px-4 py-1 text-white bg-[#1F2937] rounded-md hover:bg-gray-700 active:scale-95 transition duration-300 ease-in-out shadow-md">
  Go Back
</button>
</Link>

    <nav >
      {BASE_ITEMS.map((item,index) => (
         <Link key={'link'+index} to={`/studio/galleries/${galleryId}/${item.id}`}>
        <PanelListItem key={'studio'+index} {...item} activePanel={appState.activePanel} />
        </Link>
      ))}
    </nav>
    
  </div>
);
}







//CONTENT AREA COMPONENT
const ContentArea = ({ Icon }) => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

 // console.log("IIIIIIIIIIII ", appState.activePanel); // For debugging

  return (
  <div id="sideDetailedTray" className="flex relative w-full border-2 border-[#a5bce9] bg-white rounded-lg mt-2 mb-8 mx-2">
 
   
    {/*<StudioManager/>*/}
   { <Icon /> }
  

   {appState.activePanel !== "DeliverC" && appState.activePanel !== "VideosC"  && appState.activePanel !== "PhotosC" && appState.activePanel !== "AnalyticsC" && (
    <LinkMedia />
  )}
   
  </div>
)};







//this new folder component
const PanelListItem = ({ name, icon, txt, activePanel }) => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;  
 
  
  const Icon = Icons[icon];
 
  return (
    <div
    id="EditorPanelList"
 
    onClick={() => {

var obj = {
  activePanel: name
}
 
console.log("CLICK ",name)
setAppState((prevState) => {
  return { ...prevState, 
    activePanel:name,
 
  
  };
});

    }}

    className={`px-4 w-full h-16 flex items-center text-sm font-medium select-none transition-all duration-500 gap-2 cursor-pointer 
      ${name === activePanel ? "bg-[#1F2937] text-[#ffffff]" : "bg-gray-200 "} 
      ${name === activePanel ? "hover:text-[#ffffff]" : "hover:text-[#1F2937]"} 
      hover:transition-all hover:duration-1000`}

  >
        <Icon />
    <div>{txt}</div>

  </div>
  );
};

export default SideNav;
